import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import me from '@/plugins/graphql/queries/me.gql';
import PageTitle from '@/components/v2/PageTitle.vue';
import Affiliates from '@/components/v2/affiliate/Affiliates.vue';
import ActionButton from '@/components/action_button/Index.vue';
import AffiliateInviteForm from '@/components/v2/affiliate/AffiliateInviteForm.vue';
import SalesPartnerPayoutWidget from '@/components/v2/affiliate/SalesPartnerPayoutWidget';
import SalesPartnerWelcomeDialog from '@/components/v2/affiliate/SalesPartnerWelcomeDialog.vue';
import AffiliateMixin from '@/helpers/mixins/AffiliateMixin';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let AffiliateManager = class AffiliateManager extends Mixins(AffiliateMixin, RouterPathMixin, ViewportSizeMixin) {
    openSalesPartnerGoogleForm() {
        window.open('https://forms.gle/mArz7sY1Dmk8QnGm7');
    }
    roleUuidSlug(uuid, role = 'reseller') {
        return `${role}:${uuid}`;
    }
    mounted() {
        // Will use $nextTick here so that it can synchronously wait graphql request if done
        this.$nextTick(() => {
            const matcher = new RegExp(`${this.roleUuidSlug(this.me.uuid)}`);
            const { resellerUuid } = this.$route.params;
            // ensure that role is reseller and me uuid is equal to passed param
            if (!!this.me && !matcher.test(`${this.roleUuidSlug(resellerUuid, this.sessionRole)}`)) {
                this.$router.push('/apps');
            }
        });
    }
};
__decorate([
    Getter('role', { namespace: 'session' })
], AffiliateManager.prototype, "sessionRole", void 0);
AffiliateManager = __decorate([
    Component({
        components: {
            PageTitle,
            Affiliates,
            AffiliateInviteForm,
            SalesPartnerPayoutWidget,
            SalesPartnerWelcomeDialog,
            ActionButton,
        },
        apollo: {
            me: {
                query: me,
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
        mounted() {
            const fromEmail = this.$router.currentRoute.query.from_email;
            if (!fromEmail) {
                this.$router.push({ name: 'affiliate-invites' });
            }
        },
    })
], AffiliateManager);
export default AffiliateManager;
